import React from 'react'
import { useSelector, useDispatch, useStore } from 'react-redux'
import classnames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'

import Link from 'components/widgets/Link'
import routerSelectors from 'store/selectors/router'

const useStyles = makeStyles(theme => {
  return {
    ul: {
      listStyleType: 'none',
      textAlign: 'right',
    },
    li: {
      float: 'left',
    },
    link: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      display: 'flex',
      fontSize: '0.875rem',
      marginTop: '0px',
      textAlign: 'left',
      alignItems: 'center',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontWeight: '500',
      lineHeight: '1.75',
      marginLeft: '4px',
      marginRight: '4px',
      marginBottom: '0px',
      flexDirection: 'row',
      letterSpacing: '0.02857em',
      textTransform: 'uppercase',
      justifyContent: 'flex-start',
      padding: '8px 16px',
      borderRadius: '8px',
      textDecoration: 'none',
      '&:hover': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
      }
    },
    activeLink: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
    }
  }
})

const LinkMenu = ({
  items,
}) => {
  const dispatch = useDispatch()
  const store = useStore()
  const classes = useStyles()
  const route = useSelector(routerSelectors.route)
  return (
    <ul className={ classes.ul }>
      {
        items.map((item, i) => {

          if(typeof(item) == 'string') return null
          
          const linkClassname = classnames(classes.link, {
            [classes.activeLink]: item.link == route.name,
          })

          const linkProps = {}

          if(item.handler) {
            linkProps.url = '/logout'
            linkProps.onClick = (e) => {
              e.preventDefault()
              e.stopPropagation()
              item.handler(dispatch, store.getState)
              return false
            }
          }
          else if(item.link) {
            linkProps.name = item.link
          }

          return (
            <li key={ i } className={ classes.li }>
              <Link
                className={ linkClassname }
                { ...linkProps }
              >
                { item.title }
              </Link>
            </li>
          )
        })
      }
    </ul>
  )
}

export default LinkMenu
